import {Directive, Input, Optional, TemplateRef} from '@angular/core';

@Directive({
  selector: '[gnTableColumn]'
})
export class GnTableColumnDirective {

  @Input('gnTableColumn') set setId(value: string) {
    this.id = value;
  }

  @Input() id: string;
  @Input() title: string;
  @Input() pipe: string;
  @Input() pipeArgs: any[];



  constructor(@Optional() public templateRef: TemplateRef<any>) {
  }

}
